















































import Vue, { PropOptions } from 'vue';
import {NOC, moment} from '@/class';

import GadgetFrame, {IFrame, CFrame} from './GadgetFrame.vue';
import SelectBox, {IOption} from '@/components/util/SelectBox.vue';

// Datepicker
import DatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';

// 通信
import API from '@/api/common';
import * as models from '@/class/models/views/graph';

const GRAPH_HW = 248;

export default Vue.extend({
  name: 'CSVDLGadget',
  components: { GadgetFrame, SelectBox, DatePicker },
  props: {
    baseFrameData: Object as PropOptions<IFrame>,
    gadgetData: Object as PropOptions<models.IGadget>,
  },
  data() {
    return {
      csvtitle: 'CSVダウンロード',
      error: false,
      date: moment.fncGetLastMonthDateStr(),
      dateto: moment.fncGetLastMonthDateStr(),
      ct1Options: [NOC.SELECT.NOSELECT] as IOption[],
      ct1Value: 0,
      ct1Back: '[]',
      ct1ValueBack: 0,
      ct1Flag: false,
      downloading: false,
      dummyMaterials: {
        target: [ NOC.GRAPH.MATERIAL.V2.MATERIAL[0], NOC.GRAPH.MATERIAL.V2.MATERIAL[4]] as any[],
        measure: [ NOC.GRAPH.MATERIAL.V2.MATERIAL[5] ] as any[],
        dimension: [ NOC.GRAPH.MATERIAL.V2.MATERIAL[11] ] as any[],
        selectGraph: { key: '', value: 'radar-chart', id: 0 },
      } as any,
      tooltip: false,
      DatePickerDate: 'yyyy/MM/dd',
      ja,
    };
  },
  computed: {
    dynamicId() {
      return  String(Math.random());
    },
  },
  async mounted() {
    if (this.gadgetData.data.values.date) {
      this.date = this.gadgetData.data.values.date;
    }
    if (this.gadgetData.data.values.dateto) {
      this.dateto = this.gadgetData.data.values.dateto;
    } else {
      this.dateto = this.date;
    }
    const api = new API();
    const res = await api.post<any, IOption[]>('gadget/ct1', NOC.GRAPH.MATERIAL.V2.MATERIAL[0]);
    if (res.result) {
      if (res.data.length > 0) {
        this.ct1Options = this.ct1Options.concat(res.data);
        this.ct1Flag = true;
      }
    }
  },
  // created() {
  //  this.triggerEvent();
  // },
  methods: {
    atherAction() {
      this.$emit('ather');
    },
    onShowDetail() {
      if (this.ct1Value === 0) {
        return;
      }
      this.tooltip = false;
      const values = {
        setData: this.ct1Value.toString(),
        date: this.date,
        dateto: this.dateto,
      } as models.IValues;
      this.setData();
      this.$emit('showDetail', values);
    },
    class_disabled() {
      return {btn_disabled: this.ct1Value === 0};
    },
    async onDlCSV() {
      if (this.ct1Value === 0 || this.downloading) {
        return;
      }
      this.downloading = true;
      this.setData();
      const api = new API();
      /*
      const requestData = {
        materials: this.dummyMaterials,
        page: 0,
        csv: true,
      };
      */
      const requestData = {
        values: {
          setData: this.ct1Value.toString(),
          date: this.date,
          dateto: this.dateto,
        } as models.IValues,
        page: 0,
        csv: true,
      };
      const res = await api.post<any, any>('gadget/basic_graph/detail', requestData);
      this.downloading = false;
      if (res.result) {
        // console.log(res.data);
      }
    },
    setData() {
      (this as any).dummyMaterials.target[0].value = this.ct1Value;
      // console.log(this.date);
      this.dummyMaterials.target[1].value = this.date;
    },
    isDateError() {
      return new Date(this.date) > new Date(this.dateto);
    },
  },
  directives: {
    DatePicker,
  },
  watch: {
    date(to) {
      this.$emit('setValues', [this.gadgetData, {setData: '', date: to, dateto: this.dateto} as models.IValues]);
      this.date = moment.fncChangeDateToInputForm(new Date(this.date));
    },
    dateto(to) {
      this.$emit('setValues', [this.gadgetData, {setData: '', date: this.date, dateto: to} as models.IValues]);
      this.dateto = moment.fncChangeDateToInputForm(new Date(this.dateto));
    },
  },
});
